// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
:host {
    --gw-modal-shadow-v2: 
        /* left inner line */ 1px 0 0 0
            rgba(0, 0, 0, 0.13) inset,
        /* right inner line */ -1px 0 0 0 rgba(0, 0, 0, 0.13) inset,
        /* top inner line */ 0 -1px 0 0 rgba(0, 0, 0, 0.17) inset,
        /* bottom inner line */ 0 1px 0 0 rgba(204, 204, 204, 0.5) inset,
        /* outer soft shadow */ 0 3px 1px -1px rgba(26, 26, 26, 0.07);
}
`, "",{"version":3,"sources":["webpack://./src/themes/default_v2/modal.css"],"names":[],"mappings":"AAAA;;IAEI;;;;;;qEAMiE;AACrE","sourcesContent":[":root,\n:host {\n    --gw-modal-shadow-v2: \n        /* left inner line */ 1px 0 0 0\n            rgba(0, 0, 0, 0.13) inset,\n        /* right inner line */ -1px 0 0 0 rgba(0, 0, 0, 0.13) inset,\n        /* top inner line */ 0 -1px 0 0 rgba(0, 0, 0, 0.17) inset,\n        /* bottom inner line */ 0 1px 0 0 rgba(204, 204, 204, 0.5) inset,\n        /* outer soft shadow */ 0 3px 1px -1px rgba(26, 26, 26, 0.07);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
